'use client'

import * as React from 'react'
import { cn } from '../../helpers/index.js'
import { Heading, Text } from '../../components/index.js'
import type { SceneShelfSemanticName } from './types.js'

export interface SceneShelfRootProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 主标题 */
  title?: string
  /** 副标题 */
  subtitle?: string
  theme?: 'light' | 'dark'
  /** 语义化类名 */
  classNames?: Partial<Record<SceneShelfSemanticName, string>>
  /** 子组件（多个 Scene） */
  children: React.ReactNode
}

/**
 * SceneShelf Root 组件
 *
 * @description 最外层容器，包含标题和多个场景
 */
const SceneShelfRoot = React.forwardRef<HTMLDivElement, SceneShelfRootProps>(
  ({ title, subtitle, theme = 'light', classNames, className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'text-info-primary w-full',
          {
            'aiui-dark': theme === 'dark',
          },
          className,
          classNames?.root
        )}
        {...props}
      >
        {/* 标题区域 */}
        {(title || subtitle) && (
          <div className={cn('mb-6', classNames?.header)}>
            {title && (
              <Heading as="h2" size={4} className={cn('text-info-primary mb-2', classNames?.title)} html={title} />
            )}
            {subtitle && <Text as="p" size={3} className={cn('', classNames?.subtitle)} html={subtitle} />}
          </div>
        )}

        {/* 场景列表 */}
        <div className={cn('space-y-6', classNames?.sceneList)}>{children}</div>
      </div>
    )
  }
)

SceneShelfRoot.displayName = 'SceneShelf.Root'

export { SceneShelfRoot }
